var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-1"},[_vm._t("left"),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }